// import '../_top/_svg.js'
export default class Top {
  constructor() {
    this.$window = $(window)
    this.$logo1 = $('#logo1')
    this.$logo2 = $('#logo2')
    this.$loading = $('#loading')
    this.$wrapper = $('#wrapper')
    this.$navbar = $('#navbar')
    this.$headerMenu = $('#headerMenu')
    this.$menu = $('#menu')
    this.$bgImg = $('#bgImg')
    this.$bgVideo = $('#bgVideo')
    this.$bgLogo = $('#bgLogo')
    this.$bgVolume = $('#bgVolume')
    this.$bgArrow = $('#bgArrow')
    this.$bgImgPCImgList = $('#bgImgPC').find('img')
    this.$bgImgSPImgList = $('#bgImgSP').find('img')
    this.$spVideoArea = $('#spVideoArea')
    this.$spVideoWrap = $('#spVideoWrap')
    this.$spVideo = $('#spVideo')
    this.$sectionNews = $('#sectionNews')
    this.$closeVideoBtn = $('#closeVideoBtn')
    this.$galleryBtn = $('#galleryBtn')
    this.$galleryDetail = $('#galleryDetail')
    this.$ticketBtn = $('#ticketBtn')
    this.$ticketDetail = $('#ticketDetail')
    this.$modalWrap = $('#modalWrap')
    this.$modalClose = $('#modalClose')
    this.device = 'pc'
    this.durationTimeOp = 500
    this.durationTimeScene = 2000
    this.durationLogo = 2000
    this.swiper
    this.swiperSP
    this.videoHeight = 0
    this.spAnimCnt = 0
    this.spAnimDuration = 5000
    this.player
    this.spYoutubeHeight = 211
    // this.galleryMovieStartBtn = $("#galleryVideoIcon").img
    // this.galleryMovieIcon = $("#galleryVideoIcon")
    // this.galleryMovie
    this.$galleryMoreButton = $('#galleryMoreButton')


    this.init()
  }

  init() {
    this.getNews()
    this.isSmartPhone()
    this.setDomState()
    this.setScrollSpy()
    this.setEvent()
    this.startOpening()
    // this.scrollEase()
    this.svgSetting()
    this.svgSetting()
    this.galleryMoreButton()
    // this.resizeEvent()
    // this.onYouTubeIframeAPIReady()
    // this.galleryMovieStart()
  }

  setCoolie(){
    $.cookie('dejima110_init', '1');
    $.removeCookie('dejima110_init');
  }

  getNews() {
    $.getJSON('./assets/json/news.json', res => {
    // $.getJSON('/nijojo/assets/json/news.json', res => {
      if(res.show) {
        this.$sectionNews.addClass('on')
        this.createDomNews(res.news)
      }
    })
  }

  createDomNews(val) {
    let str_dom = ''
    for(let i=0; i<val.length; i++) {
      if(val[i] && val[i].article_show) {
        str_dom += '<article>'
                +  '<small class="news-date">'
                +  (val[i].year ? `<time>${val[i].year}</time>.` : '')
                +  `<time>${val[i].month}</time>.<time>${val[i].day}</time>.`
                +  (val[i].youbi ? ` (${val[i].youbi})`: '')
                +  '</small>'
                // +  '<h4 class="news-title">'
                // +  '<span class="news-date">'
                // +  (val[i].year ? `<time>${val[i].year}</time>年` : '')
                // +  `<time>${val[i].month}</time>月<time>${val[i].day}</time>日`
                // +  (val[i].youbi ? ` (${val[i].youbi})`: '')
                // +  '</span>'
                // +  `<span class="news-title">${val[i].title}</span>`
                +  `<h4 class="news-title">${val[i].title}</h4>`
                // +  '</h4>'
                +  `<p>${val[i].content}</p>`
                +  '</article>'
      }
    }
    $('#newsContent').html(str_dom)
  }

  isSmartPhone() {
    if (navigator.userAgent.match(/iPhone|Android.+Mobile/)) {
      this.device = 'sp'
    }
  }

  setDomState() {
    this.$galleryDetail.hide()
    this.$ticketDetail.hide()

    if(this.device === 'pc') {
      this.$spVideoArea.addClass('off')
    } else if(this.device === 'sp') {
      this.$bgVideo.remove()
      this.setSpDom()
    }
  }

  setSpDom() {
    const w = this.$window.width()
    const h = this.$window.height()

    this.videoHeight = w * 0.562667

    this.$spVideo.css({
      width: w,
      height: this.videoHeight,
    })

    this.$spVideoWrap.css({
      top: h / 2 - this.videoHeight / 2
    })

    if (h > w) {
      this.$closeVideoBtn.css({
        top: h / 2 - this.videoHeight / 2 - this.$closeVideoBtn.height() / 2 - 20,
        right: 2
      })
    }
  }

  setScrollSpy() {
    const scrollspy = new VanillaScrollspy(this.$navbar[0])
    scrollspy.init()
  }

  setEvent() {
    this.$headerMenu.on('click', () => { this.menuCtrl() })
    this.$menu.find('li').on('click', (e) => { this.menuSelect(e) })
    this.$bgArrow.on('click', () => { this.menuMove('sectionOutline') })
    this.$bgVolume.on('click', () => { this.onVolumeMovie() })
    this.$sectionNews.on('click', '.news_link', (e) => {this.openModal(e)})
    this.$modalClose.on('click', (e) => {this.closeModal(e)})
    this.$closeVideoBtn.on('click', () => { this.onCloseMovie() })
    this.$galleryBtn.on('click', () => { this.galleryDetailOpen() })
    this.$ticketBtn.on('click', () => { this.thicketDeitailOpen() })

    if(this.device === 'sp') {
      this.$window.resize(() => { this.setSpDom() })
    }
  }

  menuCtrl() {
    if(this.$menu.hasClass('on')) {
      this.menuClose()
    } else {
      this.menuOpen()
    }
  }

  menuOpen() {
    $('html,body').css({overflow: 'hidden'})
    this.$window.on('touchmove.noScroll', (e) => {
      e.preventDefault();
    })
    this.$headerMenu.addClass('on')
    this.$menu.addClass('on')
  }

  menuClose() {
    $('html,body').css({overflow: 'visible'})
    this.$window.off('.noScroll')
    this.$headerMenu.removeClass('on')
    this.$menu.removeClass('on')
  }

  menuSelect(e) {
    this.menuClose()
    const id = $(e.currentTarget).attr('data-link')
    this.menuMove(id)
  }

  menuMove(id) {
    console.log( $(`#${id}`) );
    const offsetTop = $(`#${id}`).offset().top;

    // $("html, body").animate({ scrollTop: offsetTop }, 200)
    if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
      $("html, body").animate({scrollTop:offsetTop}, 500);
    } else {
      $("html, body").animate({scrollTop:offsetTop}, 500);
      // $("html, body").animate({scrollTop:offsetTop}, speed, 200);
    }
  }

  onVolumeMovie() {
    const images = this.$bgVolume.find('img')
    const video = this.$bgVideo[0]

    if(this.player.isMuted()) {
      this.player.unMute()
      images.eq(0).removeClass('opa0').addClass('opa1')
      images.eq(1).removeClass('opa1').addClass('opa0')
    } else {
      this.player.mute()
      images.eq(0).removeClass('opa1').addClass('opa0')
      images.eq(1).removeClass('opa0').addClass('opa1')
    }
  }

  startOpening() {
    const cookie = String($.cookie('dejima110_init'));
    if(cookie !== "undefined"){
      this.switchScene()

      if(this.device === 'pc') {
        this.onYouTubeIframeAPIReady()
      } else {
        this.onYouTubeIframeAPIReadySP()
      }
    }else{
      this.$logo1.velocity(
        {opacity: 1},
        {delay: 500, duration: 0}
      )

      this.$logo2.velocity(
        {opacity: 1},
        {delay: 500, duration: this.durationTimeOp}
      )

      this.$logo1.velocity(
        {opacity: 0},
        {
          delay: 1000,
          duration: this.durationTimeOp,
          complete: () => {
            this.switchScene()

            if(this.device === 'pc') {
              this.onYouTubeIframeAPIReady()
            } else {
              this.onYouTubeIframeAPIReadySP()
            }
          }
        }
      )
    }
  }

  switchScene() {
    const cookie = String($.cookie('dejima110_init'));
    const speed = (cookie !== "undefined")?0:this.durationTimeScene;
    console.log("cookie:",cookie)
    // console.log("speed:",speed)
    this.setCoolie()
    this.$loading.velocity(
      // {opacity: 0},
      // {duration: speed, display: 'none'}
    )
    this.$wrapper.velocity(
      {opacity: 1},
      {
        // duration: speed,
        duration: 500,
        display: 'block',
        complete: () => {
          if(this.device === 'sp') {
            this.showKvLogo()
          }

          this.pcKvAnimation()
          this.spKvAnimation()
          this.setSwiper()
          this.setPasePos()
        }
      }
    )

    console.log("test---------");
    // let url = location.href;

    // if(url.indexOf("?id=") != -1){
    //     let id = url.split("?id=");
    //     let backPos = id[1];
    //     let $target = $('#' + id[id.length - 1]).get();
    //     console.log($target);

    //     if ($target.length > 0) {
    //       console.log($('#' + backPos ));
    //       console.log($('#' + backPos ).offset.top);
    //       console.log($('#' + backPos ).offset());
    //       // let $position = $target.offset().top;
    //       let $position = $('#' + backPos )[0].offsetTop;
    //       console.log($position);
    //       let menuH = 20;
    //       let position;
    //       if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
    //         if ( backPos == "sectionFood" ) {
    //           // position = 4550;
    //           position = $position - menuH;
    //         } else if ( backPos == "sectionPerformingArts" ) {
    //           // position = 7200;
    //           position = $position - menuH;
    //         } else if ( backPos == "sectionTicket" ) {
    //           // position = 10100;
    //           position = $position - menuH;
    //         } else {
    //           position = 0;
    //         }
    //         console.log(position);
    //         $("html, body").animate({scrollTop:position }, 100, "swing");
    //       } else {
    //         // console.log("test----- pc");
    //         if ( backPos == "sectionFood" ) {
    //           position = 4120;
    //         } else if ( backPos == "sectionPerformingArts" ) {
    //           position = 5720;
    //         } else if ( backPos == "sectionTicket" ) {
    //           position = 8200;
    //         } else {
    //           position = 0;
    //         }
    //         console.log(position);
    //         $("html, body").animate({scrollTop:position }, 100 ,"swing");
    //       }
    //     }
    // }
  }

  openModal(e) {
    const kind = e.currentTarget.dataset.modal

    $('.modal-text').each( function( index, element ){
      ($(element).hasClass(kind))?$(element).show():$(element).hide();
    })

    $('html,body').css({overflow: 'hidden'})
    this.$window.on('touchmove.noScroll', (e) => {
      e.preventDefault();
    })

    this.$modalWrap.addClass('on')

    const container = document.querySelector('.modal-scroll')
    container.scrollTop = 0

    const ps = new PerfectScrollbar('.modal-scroll')
  }

  closeModal() {
    $('html,body').css({overflow: 'visible'})
    this.$window.off('.noScroll')
    this.$modalWrap.removeClass('on')
  }
// d
  onCloseMovie() {
    this.$spVideoArea.addClass('off')
    this.player.pauseVideo()
  }

  galleryDetailOpen() {
    this.$galleryDetail.slideToggle()
    this.$galleryBtn.hide()
  }

  thicketDeitailOpen() {
    this.$ticketDetail.slideToggle()
    this.$ticketBtn.hide()
  }

  showKvLogo() {
    // this.$bgLogo.velocity(
    //   {opacity: 1},
    //   {
    //     delay: 1000,
    //     duration: this.durationLogo
    //   }
    // )
  }

  setSpKvHeight() {
    let spWindowHeight = $(window).height();
    let $bgImgSP = $("#bgImgSP");
    let $topInner = $(".top-inner");
    let $sectionTop = $("#sectionTop");

    if ( spWindowHeight <= 568 ) {
      spWindowHeight = 568;
    }
    let innerHeight = spWindowHeight - 35;
    // kv height set
    $sectionTop.css('height', spWindowHeight);
    $topInner.css('height', spWindowHeight);
    $bgImgSP.css('height', innerHeight);
  }

  pcKvAnimation() {
    // target.addClass('slideShow slideZoom')

    const target = this.$bgImgPCImgList.eq(this.spAnimCnt)
    // console.log( target );
    target.addClass('slideShow slideZoom')

    setTimeout(() => {
      target.removeClass('slideShow slideZoom')

      if(this.spAnimCnt < this.$bgImgSPImgList.length-1) {
        this.spAnimCnt++
      } else {
        this.spAnimCnt = 0
      }

      this.pcKvAnimation()
    }, this.spAnimDuration)
  }

  spKvAnimation() {
    this.setSpKvHeight()
    // target.addClass('slideShow slideZoom')

    const target = this.$bgImgSPImgList.eq(this.spAnimCnt)
    // console.log( target );
    target.addClass('slideShow slideZoom')

    setTimeout(() => {
      target.removeClass('slideShow slideZoom')

      if(this.spAnimCnt < this.$bgImgSPImgList.length-1) {
        this.spAnimCnt++
      } else {
        this.spAnimCnt = 0
      }

      this.spKvAnimation()
    }, this.spAnimDuration)
  }

  setSwiper() {
    this.swiper = new Swiper("#gallerySP", {
      speed: 1500,
      autoplay: {
        delay: 1500
      },
      loop: true,
      navigation: {
        // nextEl: '.swiper-button-next',
        // prevEl: '.swiper-button-prev',
      },
      // pagination: {
      //   el: '.swiper-pagination',
      //   type: 'bullets',
      //   clickable: true,
      // }
    })
  }

  spVideoSizeSet() {
    this.videoHeight = this.$window.width() * 0.562667

    this.$spVideo.css({
      width: this.$window.width(),
      height: this.videoHeight,
    })

    this.$spVideoWrap.css({
      top: this.$window.height() / 2 - this.videoHeight / 2
    })
  }

  onYouTubeIframeAPIReady() {
    const f = () => {
      this.player = new YT.Player(
        'bgImg',
        {
          width: this.$bgImg.width(),
          height: this.$bgImg.height(),
          videoId: 'HXja2XvXCD0',
          playerVars: {
            controls: 0,
            disablekb: 1,
            loop: 1,
            rel: 0,
            modestbranding: 1
          },
          events: {
            onReady: (e) => {
              this.onPlayerReady(e)
            },
            onStateChange: (e) => {
              this.onPlayerStateChange(e)
            }
          }
        }
      )
    }
    // setTimeout(()=>{
    //   (YT.Player)?f():this.onYouTubeIframeAPIReady();
    // },100);
  }

  onYouTubeIframeAPIReadySP() {
    const f =()=>{
      this.player = new YT.Player(
        'spVideo',
        {
          width: $(window).width(),
          height: this.spYoutubeHeight,
          videoId: 'HXja2XvXCD0',
          playerVars: {
            autoplay: 1,
            controls: 0,
            disablekb: 1,
            loop: 1,
            rel: 0,
            modestbranding: 1
          },
          events: {
            onStateChange: (e) => {
              this.onPlayerStateChange(e)
            }
          }
        }
      )
    }
    setTimeout(()=>{
      (YT.Player)?f():this.onYouTubeIframeAPIReadySP();
    },100);
  }

  onPlayerReady(e) {
    if(this.player && this.player.playVideo && e.target && e.target.playVideo) {
      this.onVolumeMovie()

      setTimeout(() => {
        e.target.playVideo()
      }, 500)
    } else {
      setTimeout(() => {
        this.onPlayerReady(e)
      }, 500)
    }
  }

  onPlayerStateChange(e) {
    if(e.data == -1) {
      this.player.playVideo()
    }

    if(e.data == YT.PlayerState.ENDED) {
      this.player.playVideo()
    }

    if(e.data === YT.PlayerState.PAUSED) {
      if(this.device === 'pc') {
        this.player.playVideo()
      }
    }
  }

  scrollEase() {
    $('a[href^="#"]').click(function(){
      let speed = 500;
      let href= $(this).attr("href");
      let target = $(href == "#" || href == "" ? 'html' : href);
      let position = target.offset().top;
      // $("html, body").animate({scrollTop:position}, speed, "swing");
      // return false;
      if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
        position = position - 20;
        $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
      } else {
        $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
      }
    });
  }

  svgSetting() {
    $('img.svg').each(function() {
      const $img = $(this);
      const imgID = $img.attr('id');
      const imgClass = $img.attr('class');
      const imgURL = $img.attr('src');

      $.get(imgURL, (data) => {
        let $svg = $(data).find('svg');

        if(typeof imgID !== 'undefined') {
          $svg = $svg.attr('id', imgID);
        }
        if(typeof imgClass !== 'undefined') {
          $svg = $svg.attr('class', imgClass+' replaced-svg');
        }

        $svg = $svg.removeAttr('xmlns:a');

        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
          $svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
        }

        $img.replaceWith($svg);
      }, 'xml');
    });
  }

  galleryMoreButton() {
    let galleryShow = $(".gallery-wrap");
    let galleryMoreButton = $("#galleryMoreButton");
    this.$galleryMoreButton.on('click', function () {
      // console.log( "galley more" );
      // console.log( galleryShow );
      galleryShow.removeClass("gallery-more");
      galleryMoreButton.addClass("galleryMoreButtonHide");
    });
  }

  setPasePos() {
    let url = location.href;

    if(url.indexOf("?id=") != -1){
        let id = url.split("?id=");
        let backPos = id[1];
        let $target = $('#' + id[id.length - 1]).get();
        // console.log($target);

        if ($target.length > 0) {
          // console.log($('#' + backPos ));
          // console.log($('#' + backPos ).offset.top);
          // console.log($('#' + backPos ).offset());
          // let $position = $target.offset().top;
          let $position = $('#' + backPos )[0].offsetTop;
          console.log($position);
          let menuH = 0;
          let position;
          if (navigator.userAgent.match(/(iPhone|iPad|iPod|Android)/i)) {
            // if ( backPos == "sectionFood" ) {
            //   // position = 4550;
            //   position = $position - menuH;
            // } else if ( backPos == "sectionPerformingArts" ) {
            //   // position = 7200;
            //   position = $position - menuH;
            // } else if ( backPos == "sectionTicket" ) {
            //   // position = 10100;
            //   position = $position - menuH;
            // } else {
            //   position = 0;
            // }
            menuH = 10;
            position = $position - menuH;
            // console.log(position);
            $("html, body").animate({scrollTop:position }, 1, "swing");
          } else {
            // console.log("test----- pc");
            // if ( backPos == "sectionFood" ) {
            //   position = 4120;
            // } else if ( backPos == "sectionPerformingArts" ) {
            //   position = 5720;
            // } else if ( backPos == "sectionTicket" ) {
            //   position = 8200;
            // } else {
            //   position = 0;
            // }
            menuH = 50;
            position = $position - menuH;
            // console.log(position);
            $("html, body").animate({scrollTop:position }, 1 ,"swing");
          }
        }
    }
  }
}

// $(function() {
//   const top = new Top()
// })
(function(){
  $(function () {
    const top = new Top()

  });
})();
